<script>
    import { onMount, createEventDispatcher } from "svelte";
    import { add_attribute } from "svelte/internal";

    const dispatch = createEventDispatcher();

    function addTitle() {
        dispatch("addTitle", { text: "Dashboard" });
    }

    onMount(() => {
        addTitle();
    });
</script>

<main>
    <div class="mainContainer">Main - Dash</div>
</main>

<style>
</style>
